import { NavLink } from 'react-router-dom'
import { app_name, FacebookIcon, InstagramIcon, phone_number_1, email, RightArrowIcon, facebook_link, instagram_link, important_links, whatsapp_channel_link, GroupWhatsappIcon, whatsapp_link, WhatsappIcon } from '../../base'
import { Call, Whatsapp, Email } from '../../Componets'


function Footer() {
  return (
    <footer>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-6 aboutUs'>
            <div className=' heading h5 mt-4 mt-md-2'>Who We Are ? </div>
            <div className='h6'>{app_name} – Where Heritage Meets Elegance</div>
            <div className='h7'>Preserving tradition, empowering artisans, and delivering the finest Maheshwari weaves—crafted with heritage, worn with pride.
              <div className='mt-2 h6'><span className='tcolor'>Owner </span>: Kamal Ramnarayan Mahajan</div>
              <div className='mt-2 h6'><span className='tcolor'>Add. </span>: Dhan Mandi Tilak Marg, Maheshwar, Madhya Pradesh</div>
              <div className=' h6 d-flex gap-2 mt-2 mb-2'><Call number={phone_number_1} color='fcolor' /></div>
              <div className='h6 d-flex gap-2'><Whatsapp number={phone_number_1} color='fcolor' /></div>
              <div className='h6 d-flex gap-2 mt-2'><Email email={email} color='fcolor' /></div>
            </div>
          </div>
          <div className='col-sm-7 col-md-7 col-lg-3'>
            <div className='ms-0 heading h5 mt-4 mt-md-2'>Explore More</div>
            <div className='footerLinks'>
              {
                important_links && important_links.map((item, index) => {
                  return <span key={index} className='d-flex h6 link gap-2 mt-2' style={{ alignItems: 'center' }}><RightArrowIcon /><NavLink to={item.link}>{item.name}</NavLink></span>
                })
              }
            </div>
          </div>
          <div className='col-sm-5 col-md-5 col-lg-3 social'>
            <div className='ms-0 heading h5 mt-4 mt-md-2'>Join Our Journey</div>
            <a href={instagram_link} target='_blank' rel="noopener noreferrer" className='d-flex h6 mt-3' style={{ flexDirection: 'row', gap: '10px', alignItems: 'center' }}><InstagramIcon />Instagram</a>
            <a href={whatsapp_channel_link} target='_blank' rel="noopener noreferrer" className='d-flex h6 mt-3' style={{ flexDirection: 'row', gap: '10px', alignItems: 'center' }}><GroupWhatsappIcon />Whatsapp Channel</a>
            <a href={whatsapp_link} target='_blank' rel="noopener noreferrer" className='d-flex h6 mt-3' style={{ flexDirection: 'row', gap: '10px', alignItems: 'center' }}><WhatsappIcon style = {{width : '25px'}} />Whatsapp Group</a>
            <a href={facebook_link} target='_blank' rel="noopener noreferrer" className='d-flex h6 mt-4' style={{ flexDirection: 'row', gap: '10px', alignItems: 'center' }}><FacebookIcon /> Facebook</a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer